var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dynamic-component-config-manager',{attrs:{"entry":_vm.entry}},[_c('div',{staticClass:"pa-8 purple lighten-5"},[_vm._v(" "+_vm._s(this.entry.name)+" "),_vm._l((this.children),function(renderItemChild,i){return _c('div',{key:i},[_c(_vm.ComponentTypeDictionaryService.getComponentFromDictionary(
          renderItemChild.type
        ),{tag:"component",staticStyle:{"position":"relative"},attrs:{"entry":renderItemChild}})],1)})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }